import { create } from "zustand";
import { persist } from "zustand/middleware";

const store = (set, get) => ({
  botMessages: [],
  pdMessages: [],
  indexedFile: { indexed: false, fileName: "" },
  newBotMessage: (newMessage) =>
    set((state) => ({ botMessages: [...state.botMessages, newMessage] })),
  newPDMessage: (newMessage) =>
    set((state) => ({ pdMessages: [...state.pdMessages, newMessage] })),
  resetChatMessages: () =>
    set({
      pdMessages: [],
      botMessages: [],
      indexedFile: { indexed: false, fileName: "" },
    }),
  setIndexedFile: (name) =>
    set((state) => ({ indexedFile: { indexed: true, fileName: name } })),
  removeIndexedFile: () =>
    set({ indexedFile: { indexed: false, fileName: "" } }),
});

export const useChatStore = create(persist(store, { name: "chat-store" }));
